/**
 * 站点主题 — 统一为白天（宣纸墨色）样式。
 *
 * 历史：曾按 07:00–19:00 自动在白天/夜间（body.cosmos-mode）之间切换，并允许手动切换。
 * 现已统一为白天：不再跟随时间，也不再提供切换入口；夜间 CSS 块已从 index.css 移除。
 */

const THEME_MODE = 'day' as const;
const LEGACY_THEME_KEY = 'nestmold-theme';
const LEGACY_MODE_KEY = 'nestmold-theme-mode';

/** 应用统一主题（白天）：清掉夜间类与历史遗留的本地存储 */
export function applyTheme() {
  if (typeof document === 'undefined') return;

  document.body.classList.remove('cosmos-mode');
  document.documentElement.setAttribute('data-theme', THEME_MODE);

  // 老版本可能存过 manual/night，清掉以免残留设置被误用
  try {
    localStorage.removeItem(LEGACY_THEME_KEY);
    localStorage.removeItem(LEGACY_MODE_KEY);
  } catch {
    /* 隐私模式下 localStorage 不可用 */
  }
}
